import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumsHeader from "../BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import Status from "../Status";
import Delete from "../Delete";
// import Edit from "../Edit";
import Pagination from "../TablePagination";
import TableEmptyState from "../TableEmptyState";
import CreateNewButton from "../CreateNewButton";
import { ReactComponent as Image } from "../../../Assets/Icons/Image.svg";
import { ReactComponent as LocationIcon } from "../../../Assets/Icons/Location.svg";
import { ReactComponent as ApprovedSubCategoryIcon } from "../../../Assets/Icons/approvedsubCategoryIcon.svg";
import { ReactComponent as SubCategoryIcon } from "../../../Assets/Icons/subCategoryIcon.svg";
import { ReactComponent as UnapprovedSubCatIcon } from "../../../Assets/Icons/unapprovedSubCatIcon.svg";
import { ReactComponent as ApprovedRulesIcon } from "../../../Assets/Icons/approvedRulesIcon.svg";
import { ReactComponent as RulesIcon } from "../../../Assets/Icons/rulesIcon.svg";
import { ReactComponent as UnapprovedRulesIcon } from "../../../Assets/Icons/unapprovedRulesIcon.svg";
import descriptionIcon from "../../../Assets/Icons/descriptionIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/deleteIcon.svg";
import {
  deleteOffer,
  getOfferById,
  getOffers,
  getOffersByMerchant,
  toggleOfferStatus,
} from "../../../services/offerService";
import ImagePopup from "../ImagePopup";
import LocationPopup from "../LocationPopup";
import CancelPopup from "../CancelPopup";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import { getS3PublicUrl } from "../../../utils/s3";
import Loader from "../../common/Loader";
import DetailsPopup from "../DetailsPopup";
import SubCategoryPopup from "../SubCategoryPopup";
import Confirmation from "./Confirmation";
import infoIcon from "../../../Assets/Icons/infoIcon.svg";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import SearchBar from "../SearchBar";
import debounce from "lodash.debounce";
import { Dropdown, Tooltip } from "antd";
import FilterPanel from "../FilterPanel";
import { getCategories } from "../../../services/offerService";
import DetailsModal from "../DetailsModal";
import PopupContent from "./PopupContent";
import ViewCodesModal from "./ViewCodesModal";
import AddCodesModal from "./AddCodesModal";
import ActiveFilterBar from "../../common/ActiveFilterBar";
import { Drawer as MuiDrawer } from "@mui/material";
import { formatCustomDateRangeLabel } from "../../../utils/filterLabelUtils";
import TruncatedTableCell from "../../common/TruncatedTableCell";

import { DatePicker } from "antd";
import FilterButton from "../../common/FilterButton";
import { clearAuth } from "../../../redux/slices/authSlice";
import { logout } from "../../../services/authService";
import { getFcmToken } from "../../../utils/connectStore";
import { clearClientStorage } from "../../../utils/sessionManager";
import toast from "../../../utils/toast";

// Dedupe rapid repeated fetches (e.g., StrictMode remount/effect double-fire)
const merchantOffersFetchCache = new Map();
const MERCHANT_OFFERS_FETCH_COOLDOWN_MS = 1500;
let lastCategoriesFetchAt = 0;

const MerchantOfferlist = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const selectedMerchant = useSelector(
    (state) => state?.merchantReducer.selectedMerchent,
  );
  const merchantProfiles = useSelector(
    (state) => state?.merchantReducer?.merchantProfiles?.data,
  );
  const userMerchantProfiles = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.merchantProfiles,
  );
  const effectiveMerchantId = useMemo(() => {
    const selectedId = selectedMerchant?._id || selectedMerchant?.id;
    if (selectedId) return selectedId;

    const storedMerchantId =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("swoodle_selected_merchant_id")
        : null;

    const mergedProfiles = [
      ...(Array.isArray(merchantProfiles) ? merchantProfiles : []),
      ...(Array.isArray(userMerchantProfiles) ? userMerchantProfiles : []),
    ].filter(Boolean);

    if (storedMerchantId) {
      const stored = mergedProfiles.find(
        (m) => (m?._id || m?.id) === storedMerchantId,
      );
      if (stored) return stored?._id || stored?.id;
    }

    const preferred = mergedProfiles.find((m) =>
      ["approved", "live"].includes(String(m?.status || "").toLowerCase()),
    );
    if (preferred) return preferred?._id || preferred?.id;

    const fallback = mergedProfiles.find(
      (m) =>
        !["disabled", "deleted", "declined", "rejected"].includes(
          String(m?.status || "").toLowerCase(),
        ),
    );
    return fallback?._id || fallback?.id || null;
  }, [
    selectedMerchant?._id,
    selectedMerchant?.id,
    merchantProfiles,
    userMerchantProfiles,
  ]);
  const selectedMerchantId = effectiveMerchantId;
  const loading = useSelector((state) => state?.offerReducer?.loading);
  const [allOffers, setAllOffers] = useState();
  const [hasFetchedOffers, setHasFetchedOffers] = useState(false);
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [isLocationOpen, setIsLocationOpen] = useState(false);
  const [deleteClicked, setDeleteClicked] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [isSubCategoryOpen, setIsSubCategoryOpen] = useState(false);
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const [clickedOffer, setClickedOffer] = useState(null);
  const [infoClicked, setInfoClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [offerToDelete, setOfferToDelete] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [offerDetails, setOfferDetails] = useState(null);
  const [customDate, setCustomDate] = useState([null, null]);
  const [isViewCodesModalOpen, setIsViewCodesModalOpen] = useState(false);
  const [isAddCodesModalOpen, setIsAddCodesModalOpen] = useState(false);
  const [selectedOfferForCodes, setSelectedOfferForCodes] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isFiltering, setIsFiltering] = useState(false);
  const [searchInput, setSearchInput] = useState(""); // Internal state for the input field
  const [merchantAccessModal, setMerchantAccessModal] = useState(null);
  const handledBlockedMerchantRef = useRef(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [filterParams, setFilterParams] = useState({
    category: null,
    subcategory: [], // Initialize as empty array for multi-select
    status: null,
    duration: null,
    offerType: null,
    redemptionMethod: null,
  });

  useEffect(() => {
    if (!selectedMerchantId) return;
    const now = Date.now();
    if (now - lastCategoriesFetchAt < 2000) return;
    lastCategoriesFetchAt = now;
    getCategoriesData(selectedMerchantId);
  }, [selectedMerchantId]);

  const handleMerchantAccessClose = async () => {
    const shouldLogout = merchantAccessModal?.shouldLogout === true;
    setMerchantAccessModal(null);

    if (shouldLogout) {
      try {
        await dispatch(logout({ fcmToken: getFcmToken() })).unwrap();
      } catch (error) {
        console.warn(
          "Merchant logout failed while handling blocked account:",
          error,
        );
      } finally {
        dispatch(clearAuth());
        clearClientStorage();
        localStorage.removeItem("swoodle_selected_merchant_id");
        navigate("/", { replace: true });
      }
    }
  };
  // Add these mappings
  const DURATION_MAP = {
    Today: "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };

  const STATUS_MAP = {
    Live: "approved", // Matches your enum directly
    Rejected: "rejected",
    Disabled: "pause",
    Pending: "pending", // Matches your enum directly
    Drafted: "drafted",
    "In-Progress": "in-process",
    Deleted: "deleted",
  };

  const OFFER_TYPE_MAP = {
    "In-store Offer": "INSTORE_SWOODLE_OFFER",
    "Online Offer": "ONLINE_OFFER",
  };

  const REDEMPTION_METHOD_MAP = {
    "Swoodle Code Offer": "SWOODLE_CODE_OFFER", // Based on common redemption types matching your API's IN_STORE
    "QR Code Offer": "QR_CODE", // Assuming QR/Bar Code are in-store methods
    "Bar Code Offer": "BAR_CODE", // Assuming QR/Bar Code are in-store methods
  };

  // Helper function to filter approved subcategories
  const getApprovedSubcategories = (category) => {
    if (
      !category ||
      !category.subCategory ||
      !Array.isArray(category.subCategory)
    ) {
      return [];
    }

    return category.subCategory;
  };

  // Helper function to update subcategories when a category is selected
  const updateSubcategoriesForCategory = (selectedCategory) => {
    if (!selectedCategory) return;

    // Get approved subcategories
    const approvedSubcategories = getApprovedSubcategories(selectedCategory);
    console.log("Approved subcategories:", approvedSubcategories);

    // Reset subcategory selections
    setSelections((prev) => {
      const newSelections = {
        ...prev,
        subcategory: [], // Initialize as empty array for multi-select
      };
      console.log("Reset subcategory selections:", newSelections);
      return newSelections;
    });
  };

  // Update the getCategoriesData function to populate filterData
  const getCategoriesData = async (merchantId) => {
    try {
      const categoryPromise = await dispatch(
        getCategories(merchantId ? { merchantId } : {}),
      )?.unwrap();
      if (categoryPromise?.success === true) {
        const categoriesData = categoryPromise?.data;
        setCategories(categoriesData);

        // Update selections with the first category as default if available
        if (categoriesData.length > 0) {
          // Also update subcategories based on the first category
          updateSubcategoriesForCategory(categoriesData[0]);
        }
      }
    } catch (error) {
      const message =
        error?.message ||
        error?.data?.message ||
        error?.response?.data?.message ||
        "Failed to load categories.";
      toast.error(message);
    }
  };
  // Initialize selections with the initial state
  const [selections, setSelections] = useState({
    duration: null,
    status: null,
    category: null,
    subcategory: [],
    offerType: null,
    redemptionMethod: null,
  });

  const subcategoryOptions = useMemo(() => {
    const selectedCategory = categories.find(
      (cat) => cat._id === selections.category,
    );
    return getApprovedSubcategories(selectedCategory);
  }, [categories, selections.category]);

  const filterData = useMemo(
    () => [
      {
        id: "duration",
        title: "Time Period",
        options: [
          "Today",
          "This Week",
          "This Month",
          "This Year",
          "Custom Date",
        ],
        defaultValue: null,
        multiSelect: false,
        valueMap: DURATION_MAP,
        customContent: (selected, filterParams) => {
          console.log("Custom Date selected value:", selected);
          return selected === "Custom Date" ? (
            <div
              className="mt-3 flex flex-col gap-2"
              style={{ pointerEvents: "auto", zIndex: 10000 }}
            >
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-medium text-gray-600">
                  Start Date
                </label>
                <DatePicker
                  value={customDate?.[0]}
                  onChange={(date) => {
                    console.log("Start date changed:", date);
                    const newDates = [date, customDate?.[1]];
                    setCustomDate(newDates);
                  }}
                  onClick={(e) => {
                    console.log("DatePicker clicked!", e);
                  }}
                  style={{ width: "100%", pointerEvents: "auto" }}
                  className="custom-date-picker"
                  placeholder="Select Start Date"
                  format="YYYY-MM-DD"
                  showTime={false}
                  allowClear={true}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  popupClassName="date-picker-popup"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-medium text-gray-600">
                  End Date
                </label>
                <DatePicker
                  value={customDate?.[1]}
                  onChange={(date) => {
                    console.log("End date changed:", date);
                    const newDates = [customDate?.[0], date];
                    setCustomDate(newDates);
                  }}
                  onClick={(e) => {
                    console.log("DatePicker clicked!", e);
                  }}
                  style={{ width: "100%", pointerEvents: "auto" }}
                  className="custom-date-picker"
                  placeholder="Select End Date"
                  format="YYYY-MM-DD"
                  showTime={false}
                  allowClear={true}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  popupClassName="date-picker-popup"
                />
              </div>
            </div>
          ) : null;
        },
      },
      {
        id: "status",
        title: "Status",
        options: [
          "Live",
          "Rejected",
          "Disabled",
          "Pending",
          "Drafted",
          "Deleted",
        ],
        multiSelect: false,
        valueMap: STATUS_MAP,
      },
      {
        id: "category",
        title: "Category",
        options: categories,
        defaultValue: "",
        multiSelect: false,
        optionValueKey: "_id",
        optionLabelKey: "title",
      },
      {
        id: "subcategory",
        title: "Subcategory",
        options: subcategoryOptions,
        defaultValue: [],
        multiSelect: true,
        optionValueKey: "_id",
        optionLabelKey: "title",
      },
      {
        id: "offerType",
        title: "Offer Type",
        options: ["In-store Offer", "Online Offer"],
        multiSelect: false,
        valueMap: OFFER_TYPE_MAP,
      },
      {
        id: "redemptionMethod",
        title: "Redemption Method",
        options: ["Swoodle Code Offer", "QR Code Offer", "Bar Code Offer"],
        multiSelect: false,
        valueMap: REDEMPTION_METHOD_MAP,
      },
    ],
    [categories, subcategoryOptions, customDate, selections.duration],
  );

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  // Use effect to initialize subcategories when categories are loaded
  useEffect(() => {
    console.log("useEffect for categories/selections.category:", {
      categories: categories.length,
      selectionsCategory: selections.category,
    });
    if (categories.length > 0 && selections.category) {
      const selectedCategory = categories.find(
        (cat) => cat._id === selections.category,
      );
      if (selectedCategory) {
        console.log("Found category in useEffect, updating subcategories");
        updateSubcategoriesForCategory(selectedCategory);
      }
    }
  }, [categories, selections.category]);

  // Debug useEffect to log when selections change
  useEffect(() => {
    console.log("Selections changed:", selections);
  }, [selections]);

  // Debug useEffect to log when filterData changes
  useEffect(() => {
    console.log("FilterData changed:", filterData);
  }, [filterData]);

  // Update the handleSelectionChange function
  const handleSelectionChange = (filterId, value) => {
    console.log("handleSelectionChange called", filterId, value);

    setSelections((prev) => {
      const newSelections = {
        ...prev,
        [filterId]: value,
      };
      console.log("New selections:", newSelections);
      return newSelections;
    });

    // If category changes, update subcategories
    if (filterId === "category") {
      console.log("Category changed, updating subcategories for:", value);
      // Find the selected category
      const selectedCategory = categories.find((cat) => cat._id === value);
      if (selectedCategory) {
        console.log("Found selected category:", selectedCategory);
        updateSubcategoriesForCategory(selectedCategory);
      } else {
        console.log("Category not found in categories:", categories);
      }
    }
  };

  // Removed duplicate handleReset

  // 1. Chips derivation from SELECTIONS (for immediate feedback)
  const activeFilterChips = useMemo(() => {
    const chips = [];
    Object.entries(filterParams).forEach(([key, value]) => {
      if (!value || (Array.isArray(value) && value.length === 0)) return;
      if (key === "startDate" || key === "endDate") return;

      const filter = filterData.find(
        (f) =>
          f.id === key ||
          (f.id === "category" && key === "category") ||
          (f.id === "subcategory" && key === "subCategory"),
      );
      if (!filter) return;

      const values = Array.isArray(value) ? value : [value];
      values.forEach((val) => {
        let displayLabel = null;
        if (filter.optionValueKey) {
          const opt = filter.options.find(
            (o) => o[filter.optionValueKey] === val,
          );
          displayLabel = opt ? opt[filter.optionLabelKey] : null;
        } else if (filter.valueMap) {
          displayLabel =
            Object.keys(filter.valueMap).find(
              (k) => filter.valueMap[k] === val,
            ) || null;
        }

        if (displayLabel) {
          chips.push({ id: filter.id, value: val, label: displayLabel });
        }
      });
    });

    // Special handling for custom date range label
    if (filterParams.duration === "CUSTOM") {
      const dChip = chips.find((c) => c.id === "duration");
      if (dChip) {
        dChip.label = formatCustomDateRangeLabel(
          filterParams.startDate || customDate?.[0],
          filterParams.endDate || customDate?.[1],
        );
      }
    }

    return chips;
  }, [filterParams, filterData, customDate]);

  const activeCount = activeFilterChips.length;

  const applyFilters = (sels) => {
    const mappedFilterParams = {};
    filterData.forEach((filter) => {
      const selectedValue = sels[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.id === "category") {
          mappedFilterParams.category = selectedValue;
        } else if (filter.id === "subcategory") {
          mappedFilterParams.subcategory = selectedValue;
        } else if (filter.valueMap) {
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });

    if (sels.duration === "CUSTOM") {
      if (customDate?.[0])
        mappedFilterParams.startDate = customDate[0].format("YYYY-MM-DD");
      if (customDate?.[1])
        mappedFilterParams.endDate = customDate[1].format("YYYY-MM-DD");
    }

    setFilterParams(mappedFilterParams);
  };

  const handleApply = () => {
    applyFilters(selections);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleReset = () => {
    const initialState = createInitialState(filterData);
    setSelections(initialState);
    setFilterParams({
      subcategory: [],
      status: null,
      duration: null,
      offerType: null,
      redemptionMethod: null,
    });
    setCustomDate([null, null]);
    setSearchInput("");
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleRemoveFilter = (targetChip) => {
    const filter = filterData.find((f) => f.id === targetChip.id);
    if (!filter) return;

    let newValue;
    if (filter.multiSelect) {
      newValue = selections[targetChip.id].filter(
        (v) => v !== targetChip.value,
      );
    } else {
      newValue = null;
    }

    const newSelections = { ...selections, [targetChip.id]: newValue };
    setSelections(newSelections);

    if (targetChip.id === "duration" && newValue === null) {
      setCustomDate([null, null]);
    }

    applyFilters(newSelections);
  };

  useEffect(() => {
    if (open) {
      document.body.classList.add("dropdown-open");
    } else {
      document.body.classList.remove("dropdown-open");
    }

    return () => {
      document.body.classList.remove("dropdown-open");
    };
  }, [open]);

  const items = [
    {
      title: "Offers",
    },
    {
      title: "Offers List",
    },
  ];

  const columns = [
    {
      name: "No.",
    },
    {
      name: "Title",
    },
    {
      name: "Category Type",
    },
    {
      name: "Offer Type",
    },
    {
      name: "Discount Type",
    },
    {
      name: "Status",
    },
    {
      name: "Actions",
    },
  ];

  const offersFetchKey = useMemo(
    () =>
      JSON.stringify({
        merchantId: selectedMerchantId || "none",
        filters: filterParams,
        refresh: deleteSuccess,
      }),
    [selectedMerchantId, filterParams, deleteSuccess],
  );
  const inFlightOffersKeyRef = useRef(null);

  const getOffersData = async (silent = false, { force = false } = {}) => {
    if (!selectedMerchantId) return;

    if (!force) {
      if (inFlightOffersKeyRef.current === offersFetchKey) return;
      const now = Date.now();
      const lastFetchedAt = merchantOffersFetchCache.get(offersFetchKey) || 0;
      if (now - lastFetchedAt < MERCHANT_OFFERS_FETCH_COOLDOWN_MS) return;
      merchantOffersFetchCache.set(offersFetchKey, now);
    }

    inFlightOffersKeyRef.current = offersFetchKey;
    if (!silent) setIsFiltering(true);
    const params = {
      category: filterParams.category || undefined,
      subcategory:
        filterParams.subcategory && filterParams.subcategory.length > 0
          ? filterParams.subcategory.join(",")
          : undefined,
      offerType: filterParams.offerType || undefined,
      status: filterParams.status || undefined,
      duration:
        filterParams.duration === "CUSTOM"
          ? undefined
          : filterParams.duration || undefined,
      redemptionMethod: filterParams.redemptionMethod || undefined,
      creatorRole: filterParams.creatorRole || undefined,
      merchantId: selectedMerchantId,
      limit: 500,
    };

    // Remove undefined values to avoid sending empty parameters
    Object.keys(params).forEach(
      (key) => (params[key] === undefined ? delete params[key] : null), // Use undefined for deletion logic
    );
    try {
      // Revert to getOffersByMerchant for consistency and guaranteed access for merchants
      const offersPromise = await dispatch(
        getOffersByMerchant(params),
      )?.unwrap();
      if (offersPromise?.success === true) {
        let offersData = offersPromise?.data || [];

        setAllOffers(offersData);
      }
    } catch (error) {
      const message =
        error?.message || error?.payload?.message || error?.data?.message || "";
      const blockedMerchant = error?.payload?.blockedMerchant === true;
      const normalizedMessage = String(message).toLowerCase();

      if (
        blockedMerchant ||
        normalizedMessage.includes("disabled") ||
        normalizedMessage.includes("deleted") ||
        normalizedMessage.includes("merchant account")
      ) {
        if (!handledBlockedMerchantRef.current) {
          handledBlockedMerchantRef.current = true;
          setMerchantAccessModal({
            message: normalizedMessage.includes("deleted")
              ? "Your merchant account has been deleted. Please contact support."
              : "Your merchant account has been disabled. Please contact support.",
            shouldLogout: true,
          });
        }
        return;
      }

      console.error("Error fetching offers:", error);
    } finally {
      setIsFiltering(false);
      setHasFetchedOffers(true);
      if (inFlightOffersKeyRef.current === offersFetchKey) {
        inFlightOffersKeyRef.current = null;
      }
    }
  };

  // Keep this useEffect for fetching data
  useEffect(() => {
    getOffersData();
  }, [offersFetchKey]);

  useEffect(() => {
    if (!hasFetchedOffers) return;
    if (handledBlockedMerchantRef.current) return;
    if (!selectedMerchant) return;

    const status = String(selectedMerchant?.status || "").toLowerCase();
    if (!["disabled", "deleted", "declined", "rejected"].includes(status))
      return;

    handledBlockedMerchantRef.current = true;
    setMerchantAccessModal({
      message:
        status === "deleted"
          ? "Your merchant account has been deleted. Please contact support."
          : "Your merchant account has been disabled. Please contact support.",
      shouldLogout: true,
    });
  }, [hasFetchedOffers, selectedMerchant?.status, selectedMerchantId]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    const container = document.getElementById("offer-list-container");
    if (container) {
      container.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleImageIconClick = (offer) => {
    setClickedOffer(offer);
    setIsImageOpen(true);
  };

  const handleCloseImage = () => {
    setIsImageOpen(false);
    setClickedOffer(null);
  };

  const handleLocationClick = (offer) => {
    setClickedOffer(offer);
    setIsLocationOpen(true);
  };

  const handleDescriptionClick = (offer) => {
    setClickedOffer(offer);
    setIsDescriptionOpen(true);
  };

  const handleSubCategoryClick = (offer) => {
    setClickedOffer(offer);
    setIsSubCategoryOpen(true);
  };

  const handleRulesClick = (offer) => {
    setClickedOffer(offer);
    setIsRulesOpen(true);
  };

  const handleCloseLocation = () => {
    setIsLocationOpen(false);
    setClickedOffer(null);
  };

  const handleCloseDescription = () => {
    setIsDescriptionOpen(false);
    setClickedOffer(null);
  };

  const handleCloseSubCategory = () => {
    setIsSubCategoryOpen(false);
    setClickedOffer(null);
  };

  const handleCloseRules = () => {
    setIsRulesOpen(false);
    setClickedOffer(null);
  };

  const canEditOffer = (status) => {
    const rawStatus = String(status || "").toLowerCase();
    const normalizedStatus = ["declined", "rejected"].includes(rawStatus)
      ? "rejected"
      : ["pause", "paused", "disabled"].includes(rawStatus)
        ? "disabled"
        : rawStatus;
    const inProcessStatuses = [
      "in-process",
      "in progress",
      "in-progress",
      "in process",
    ];
    const editableStatuses = [
      "drafted",
      "pending",
      "approved",
      "live",
      "disabled",
      "rejected",
    ];
    return (
      editableStatuses.includes(normalizedStatus) &&
      !inProcessStatuses.includes(normalizedStatus)
    );
  };

  const handleEditClick = (id, status, merchantId) => {
    if (!canEditOffer(status)) return;
    navigate("/merchant/offer-form", {
      state: {
        id,
        ...(merchantId ? { merchantId } : {}),
      },
    });
  };

  const handleDeleteClick = (offer) => {
    setDeleteClicked(true);
    setClickedOffer(offer);
  };

  const handleKeepOffer = () => {
    setDeleteClicked(false);
    setClickedOffer(null);
  };

  const handleDeleteOffer = async () => {
    // Close detail popup and the confirmation modal
    closePopup();
    setDeleteClicked(false);
    if (clickedOffer?._id !== null) {
      const deletePromise = await dispatch(
        deleteOffer({ id: clickedOffer?._id }),
      )?.unwrap();
      if (deletePromise?.success === true) {
        setDeleteSuccess(!deleteSuccess);
        setClickedOffer(null);
      }
    }
  };

  const handleStatusClick = async (offerId, nextStatus) => {
    const statusPromise = await dispatch(
      toggleOfferStatus({
        id: offerId,
        status: nextStatus,
        silent: true,
      }),
    )?.unwrap();

    if (statusPromise?.success === true) {
      setAllOffers((prev) =>
        Array.isArray(prev)
          ? prev.map((offer) =>
              offer?._id === offerId ? { ...offer, status: nextStatus } : offer,
            )
          : prev,
      );

      if (offerDetails?._id === offerId) {
        setOfferDetails((prev) =>
          prev ? { ...prev, status: nextStatus } : prev,
        );
      }

      toast.success(
        nextStatus === "approved"
          ? "Offer moved to live successfully"
          : nextStatus === "pause"
            ? "Offer disabled successfully"
            : statusPromise?.message || "Offer status updated successfully",
      );

      return statusPromise;
    }

    return statusPromise;
  };

  // const handleToggle = async (id) => {
  //   try {
  //     const togglePromise = await dispatch(
  //       toggleOfferStatus({ id: id })
  //     ).unwrap();
  //     if (togglePromise?.success === true) {
  //       getOffersData();
  //     }
  //   } catch (error) {
  //     console.error("Error toggling location status:", error);
  //   }
  // };

  const handleCloseInfo = () => {
    setInfoClicked(false);
    setClickedOffer(null);
  };

  const handleInfoClick = (offer) => {
    setClickedOffer(offer);
    setInfoClicked(true);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchQuery(value);
        setCurrentPage(1); // Ensure we go to the first page when search changes
      }, 2500),
    [],
  );

  const handleSearchChange = (value) => {
    setSearchInput(value); // Immediate update for UI responsive input
    debouncedSearch(value); // Wait 2.5s before updating the real query state
  };

  // Cleanup debounced search on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // Client-side filtering to include title, category title, offer type, discount type
  const filteredOffers = useMemo(() => {
    let filtered = Array.isArray(allOffers) ? [...allOffers] : [];
    const q = (searchQuery || "").toLowerCase().trim();

    // 1. Search Filtering
    if (q) {
      const normalizeOfferType = (t) => {
        if (!t) return "";
        switch (t) {
          case "ONLINE_OFFER":
            return "online offer";
          case "INSTORE_SWOODLE_OFFER":
            return "in-store offer";
          default:
            return String(t).toLowerCase();
        }
      };
      const normalizeDiscountType = (t) => {
        if (!t) return "";
        switch (t) {
          case "FREE_OFFER":
            return "free offer";
          case "DISCOUNTED_PERCENT":
            return "discounted percent";
          case "FIXED_DOLLAR":
            return "fixed dollar";
          case "BUY_ONE_GET_ONE_FREE":
            return "buy one get one free";
          case "BUNDLE_OFFER":
            return "bundle offer";
          default:
            return String(t).toLowerCase();
        }
      };
      filtered = filtered.filter((o) => {
        const title = (o?.title || "").toLowerCase();
        const category = (o?.category?.title || "").toLowerCase();
        const offerType = normalizeOfferType(o?.offerType);
        const discountType = normalizeDiscountType(o?.offerDiscountType);
        const merchantName = (
          o?.merchant?.businessName ||
          o?.merchant?.business_name ||
          ""
        ).toLowerCase();
        const brandName = (o?.brand?.name || "").toLowerCase();

        return (
          title.includes(q) ||
          category.includes(q) ||
          offerType.includes(q) ||
          discountType.includes(q) ||
          merchantName.includes(q) ||
          brandName.includes(q)
        );
      });
    }

    if (filterParams.status) {
      const normalizeOfferStatus = (status) => {
        const s = String(status || "").toLowerCase();
        if (["approved", "live", "active"].includes(s)) return "live";
        if (["declined", "rejected"].includes(s)) return "rejected";
        if (["pause", "paused", "disabled"].includes(s)) return "disabled";
        if (["pending"].includes(s)) return "pending";
        if (["draft", "drafted"].includes(s)) return "drafted";
        if (
          [
            "in-process",
            "in progress",
            "in-progress",
            "in process",
            "in_process",
            "in_progress",
          ].includes(s)
        )
          return "in-process";
        if (["deleted"].includes(s)) return "deleted";
        return s;
      };
      const selectedStatus = normalizeOfferStatus(filterParams.status);
      filtered = filtered.filter((offer) => {
        const offerStatus = normalizeOfferStatus(offer?.status);
        if (offerStatus) {
          return offerStatus === selectedStatus;
        }

        if (offer?.isCreated === false) {
          const creatorRole = String(offer?.creatorRole || "").toLowerCase();
          if (selectedStatus === "in-process") {
            return creatorRole === "merchant";
          }
          if (selectedStatus === "drafted") {
            return creatorRole !== "merchant";
          }
        }

        return false;
      });
    }

    return filtered;
  }, [allOffers, searchQuery, filterParams]);

  const visibleOffers = useMemo(() => {
    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    return filteredOffers.slice(startIndex, endIndex);
  }, [filteredOffers, currentPage]);

  useEffect(() => {
    const nextTotalPages = Math.ceil(filteredOffers.length / 10) || 1;
    const nextPage = Math.min(currentPage, nextTotalPages);

    setCount(filteredOffers.length);
    setTotalPages(nextTotalPages);
    if (nextPage !== currentPage) {
      setCurrentPage(nextPage);
    }
  }, [filteredOffers]);

  const fetchOfferDetails = async (offerId) => {
    try {
      const offerDetailsPromise = await dispatch(
        getOfferById({ id: offerId, silent: true }),
      )?.unwrap();
      if (offerDetailsPromise?.success === true) {
        setOfferDetails(offerDetailsPromise?.data);
      }
    } catch (error) {
      console.error("Error fetching offer details:", error);
    }
  };

  const resolveOfferForPopup = (offerOrId) => {
    if (!offerOrId) return null;
    if (typeof offerOrId === "object") return offerOrId;

    return (
      (Array.isArray(allOffers) &&
        allOffers.find((offer) => offer?._id === offerOrId)) ||
      null
    );
  };

  const openPopup = (offerOrId) => {
    const localOffer = resolveOfferForPopup(offerOrId);
    setOfferDetails(localOffer || null);
    setIsDetailOpen(true);

    if (!localOffer && offerOrId) {
      fetchOfferDetails(offerOrId);
    }
  };

  const closePopup = () => {
    setIsDetailOpen(false);
    // setPopupContent("");
  };

  // Open direct from navigation state (e.g., notifications deep-link)
  useEffect(() => {
    const stateOfferId =
      location?.state?.openOfferId || location?.state?.offerId;
    if (stateOfferId) {
      openPopup(stateOfferId);
      // Clear the navigation state so modal does not reopen on re-render
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [
    location?.state?.openOfferId,
    location?.state?.offerId,
    location.pathname,
    navigate,
  ]);

  const handleOpenViewCodes = (offerDetails) => {
    setIsDetailOpen(false); // Close the parent modal
    setTimeout(() => {
      setSelectedOfferForCodes(offerDetails);
      setIsViewCodesModalOpen(true);
    }, 300); // Wait for modal close animation (if any)
  };

  const handleOpenAddCodes = (offerDetails) => {
    setIsDetailOpen(false); // Close the parent modal
    setTimeout(() => {
      setSelectedOfferForCodes(offerDetails);
      setIsAddCodesModalOpen(true);
    }, 300);
  };

  const handleCloseViewCodes = () => {
    setIsViewCodesModalOpen(false);
    setSelectedOfferForCodes(null);
    setIsDetailOpen(true); // Reopen the parent modal
  };

  const handleCloseAddCodes = () => {
    setIsAddCodesModalOpen(false);
    setSelectedOfferForCodes(null);
    setIsDetailOpen(true); // Reopen the parent modal
  };

  // Handler to go from ViewCodesModal to AddCodesModal
  const handleAddCodesFromView = () => {
    setIsViewCodesModalOpen(false);
    setIsAddCodesModalOpen(true);
  };

  // No status-change UI in merchant list; admin handles status updates

  console.log("offerDetails", offerDetails);

  return (
    <div id="offer-list-container" className="offer-list-page">
      {merchantAccessModal && (
        <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/50 px-4">
          <div className="w-full max-w-[560px] rounded-[20px] bg-white px-7 py-8 md:px-10 md:py-9 shadow-2xl">
            <div className="mb-5">
              <div className="text-[22px] md:text-[24px] font-semibold text-[#111827] leading-tight">
                Business unavailable
              </div>
              <div className="mt-3 text-[15px] md:text-[16px] leading-7 text-[#4B5563] max-w-[48ch]">
                {merchantAccessModal.message}
              </div>
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                className="h-[42px] min-w-[110px] rounded-[10px] bg-[#00ADEF] px-6 text-[14px] font-semibold text-white hover:bg-[#0095c8]"
                onClick={handleMerchantAccessClose}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {(loading === true || isFiltering === true) && <Loader />}
      {clickedOffer?.thumbnailImage !== null && isImageOpen === true && (
        <ImagePopup
          image={getS3PublicUrl(clickedOffer?.thumbnailImage)}
          imagePath={clickedOffer?.thumbnailImage}
          handleCloseImage={handleCloseImage}
        />
      )}
      {isLocationOpen === true && (
        <LocationPopup
          locations={clickedOffer?.tempLocations}
          handleCloseLocation={handleCloseLocation}
        />
      )}
      {clickedOffer?.description !== "" && isDescriptionOpen === true && (
        <DetailsPopup
          content={clickedOffer?.description}
          handleClose={handleCloseDescription}
          icon={descriptionIcon}
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
        />
      )}
      {clickedOffer?.subCategory?.length > 0 && isSubCategoryOpen === true && (
        <SubCategoryPopup
          subCategories={clickedOffer?.subCategory}
          handleCloseSubCategory={handleCloseSubCategory}
          icon={<SubCategoryIcon className="w-[10%]" />}
          heading="Subcategories"
        />
      )}
      {clickedOffer?.ruleAndRegulation?.length > 0 && isRulesOpen === true && (
        <SubCategoryPopup
          subCategories={clickedOffer?.ruleAndRegulation}
          handleCloseSubCategory={handleCloseRules}
          icon={<RulesIcon className="w-[10%]" />}
          heading="Rules and Regulations"
        />
      )}
      {isDetailOpen && (
        <div className="popup-container details-modal-backdrop details-modal-backdrop-enter">
          <div className="details-modal-panel details-modal-panel-enter">
            <PopupContent
              offerDetails={offerDetails}
              handleDeleteClick={handleDeleteClick}
              handleEditClick={handleEditClick}
              onOpenViewCodes={handleOpenViewCodes}
              onOpenAddCodes={handleOpenAddCodes}
              onClose={closePopup}
              onDuplicated={() => getOffersData(false, { force: true })}
            />
          </div>
        </div>
      )}
      {isViewCodesModalOpen && (
        <ViewCodesModal
          onClose={handleCloseViewCodes}
          codes={Array(100).fill("FNPR5RG")}
          usedCount={1}
          totalCount={100}
          onAddCodes={handleAddCodesFromView}
        />
      )}
      {isAddCodesModalOpen && <AddCodesModal onClose={handleCloseAddCodes} />}
      <div className="mt-2 mb-6 col-span-12">
        {isMobile ? (
          <div className="flex flex-col gap-4">
            <div>
              <h1 className="text-[24px] font-[600] text-[#303030] font-poppins mb-1">
                Offers List
              </h1>
              <BreadCrumsHeader items={items} />
            </div>
            <CreateNewButton
              text={"Create New Offer"}
              navigateTo={"/merchant/offer-form"}
              className="!w-[190px] !h-[42px] !pl-0 !justify-center"
              containerClassName="!w-full !justify-end pr-0"
              iconClassName="!static !m-0 !translate-y-0 !w-4 !h-4"
            />
          </div>
        ) : (
          <div className="flex justify-between items-center">
            <BreadCrumsHeader heading="Offers List" items={items} />
            <CreateNewButton
              text={"Create New Offer"}
              navigateTo={"/merchant/offer-form"}
              iconClassName="sm:left-[1%] md:left-[8%] bottom-[30%]"
            />
          </div>
        )}
      </div>
      {deleteClicked === true ? (
        <CancelPopup
          handleNo={handleKeepOffer}
          handleYes={handleDeleteOffer}
          heading={"Delete Offer"}
          content={"Are you sure you want to delete this offer?"}
          icon={<DeleteIcon />}
        />
      ) : null}
      {infoClicked === true && (
        <DetailsPopup
          content={clickedOffer?.reason}
          handleClose={handleCloseInfo}
          icon={infoIcon}
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
        />
      )}
      <div className="w-full flex flex-row justify-between items-center mt-2 mb-4 gap-3">
        <SearchBar
          parentDivClass="flex-1 md:w-[400px] md:flex-none"
          divClassName="relative w-full"
          inputClassName="searchBar w-full p-3 pr-10 text-[14px] font-poppins font-[400] outline-none border border-gray-300 rounded-[5px]"
          iconClassName="absolute right-[10px] top-1/2 -translate-y-1/2 w-[22px] h-[22px]"
          placeholder="Search..."
          value={searchInput}
          handleChange={(e) => handleSearchChange(e.target.value)}
          onClear={() => handleSearchChange("")}
        />{" "}
        <div className="flex items-center gap-2">
          <FilterButton
            activeCount={activeCount}
            isOpen={open}
            onClick={() => setOpen(true)}
          />
        </div>
        <MuiDrawer
          anchor="right"
          open={open}
          onClose={() => setOpen(false)}
          ModalProps={{ keepMounted: true }}
          TransitionComponent={Slide}
          SlideProps={{
            appear: true,
            timeout: { enter: 700, exit: 500 },
            easing: {
              enter: "cubic-bezier(0.22, 1, 0.36, 1)",
              exit: "cubic-bezier(0.4, 0, 0.2, 1)",
            },
          }}
          PaperProps={{
            sx: {
              width: { xs: "100%", sm: "400px" },
              padding: "0",
              height: "100%",
            },
          }}
        >
          <FilterPanel
            filterData={filterData}
            selections={selections}
            appliedSelections={filterParams}
            handleApply={handleApply}
            handleCancel={handleCancel}
            handleReset={handleReset}
            handleSelectionChange={handleSelectionChange}
            style={{ maxHeight: "unset" }}
          />
        </MuiDrawer>
      </div>

      <ActiveFilterBar
        chips={activeFilterChips}
        onRemove={handleRemoveFilter}
        onClearAll={handleReset}
      />
      <div className="col-span-12 mt-4">
        {/* Responsive View Toggle */}
        {isMobile ? (
          /* Mobile Card View */
          <div className="md:hidden flex flex-col gap-4 mb-4">
            {visibleOffers?.map((offer, index) => (
              <div
                key={offer._id}
                className="bg-white p-4 rounded-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.10)] flex flex-col gap-3 border border-[#E0E0E0]"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-[14px] font-[600] text-[#303030] leading-tight mb-1">
                      {offer?.title || "N/A"}
                    </p>
                    <p className="text-[12px] text-[#8C8C8C]">
                      {offer?.category?.title || "N/A"}
                    </p>
                  </div>
                  <div className="min-w-[50px] flex justify-end">
                    <Confirmation
                      status={offer?.status}
                      onStatusClick={handleStatusClick}
                      offerId={offer?._id}
                      enableMerchantStatusAction={true}
                      handleInfoClick={() => handleInfoClick(offer)}
                      creatorRole={offer?.creatorRole}
                      showInProcess={false}
                      showRejectedLabel={["declined", "rejected"].includes(
                        String(offer?.status || "").toLowerCase(),
                      )}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-[12px] font-[500] text-[#303030] mt-1">
                  <div>
                    <p className="text-[#8C8C8C] text-[10px] uppercase font-semibold">
                      Offer Type
                    </p>
                    <p>
                      {offer?.offerType === "ONLINE_OFFER"
                        ? "Online Offer"
                        : offer?.offerType === "INSTORE_SWOODLE_OFFER"
                          ? "In-store Offer"
                          : "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="text-[#8C8C8C] text-[10px] uppercase font-semibold">
                      Discount
                    </p>
                    <p>
                      {(() => {
                        switch (offer?.offerDiscountType) {
                          case "FREE_OFFER":
                            return "FREE OFFER";
                          case "DISCOUNTED_PERCENT":
                            return "DISCOUNTED %";
                          case "FIXED_DOLLAR":
                            return "FIXED $";
                          case "BUY_ONE_GET_ONE_FREE":
                            return "BOGO FREE";
                          case "BUNDLE_OFFER":
                            return "BUNDLE OFFER";
                          default:
                            return "None";
                        }
                      })()}
                    </p>
                  </div>
                </div>

                <div className="mt-2 flex items-center justify-between gap-3">
                  <button
                    className="flex-1 flex justify-center items-center border border-[#00ADEF] rounded-[8px] p-2 h-[38px] bg-[#00ADEF14] hover:bg-[#00ADEF28] transition-colors duration-200"
                    onClick={() => openPopup(offer?._id)}
                  >
                    <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins">
                      View Details
                    </span>
                  </button>
                  <div className="flex items-center gap-4 px-1">
                    <Tooltip
                      title="Delete Offer"
                      color="#00ADEF"
                      trigger={isMobile ? [] : ["hover"]}
                    >
                      <DeleteIcon
                        className="w-[20px] h-[20px] cursor-pointer text-gray-500 hover:text-red-500 transition-colors"
                        onClick={() => handleDeleteClick(offer)}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            ))}
            {hasFetchedOffers &&
              !loading &&
              (!Array.isArray(visibleOffers) || visibleOffers.length === 0) && (
                <TableEmptyState itemName="Offer" />
              )}
          </div>
        ) : (
          /* Desktop Table View */
          <div className="hidden md:block">
            <TableContainer style={{ width: "100%", overflowX: "auto" }}>
              <Table
                sx={{
                  minWidth: "800px",
                  borderCollapse: "separate",
                  borderSpacing: "0px 8px",
                }}
                aria-label="simple table"
              >
                <TableHead className="bg-[#00ADEF]">
                  <TableRow
                    className="h-[50px]"
                    sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                  >
                    {columns.map((column) => {
                      return (
                        <TruncatedTableCell
                          key={column.name}
                          className="!text-[#FFFFFF]"
                          textClassName="!text-[#FFFFFF] !font-[700]"
                          title={column.name}
                          maxChars={14}
                        >
                          {column.name}
                        </TruncatedTableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {hasFetchedOffers &&
                    !loading &&
                    (!Array.isArray(visibleOffers) ||
                      visibleOffers.length === 0) && (
                      <TableRow>
                        <TableCell
                          colSpan={columns.length}
                          align="center"
                          className="!border-b-0 !p-0"
                        >
                          <TableEmptyState itemName="Offer" />
                        </TableCell>
                      </TableRow>
                    )}
                  {visibleOffers?.map((offer, index) => {
                    return (
                      <TableRow
                        className="h-[50px]"
                        sx={{
                          boxShadow: "0px 4px 4px 0px #00000040",
                          backgroundColor:
                            (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                        }}
                        key={offer._id}
                      >
                        <TruncatedTableCell className="max-w-[50px]">
                          {(currentPage - 1) * 10 + index + 1}
                        </TruncatedTableCell>
                        <TruncatedTableCell
                          className="max-w-[100px]"
                          title={offer?.title}
                        >
                          {offer?.title || "N/A"}
                        </TruncatedTableCell>
                        <TruncatedTableCell
                          className="max-w-[80px]"
                          title={offer?.category?.title}
                        >
                          {offer?.category?.title || "N/A"}
                        </TruncatedTableCell>
                        <TruncatedTableCell className="max-w-[180px]">
                          {(() => {
                            switch (offer?.offerType) {
                              case "ONLINE_OFFER":
                                return "Online Offer";
                              case "INSTORE_SWOODLE_OFFER":
                                return "In-store Offer";
                              default:
                                return "N/A";
                            }
                          })()}
                        </TruncatedTableCell>
                        <TruncatedTableCell
                          className="max-w-[80px]"
                          title={offer?.offerDiscountType}
                        >
                          {(() => {
                            switch (offer?.offerDiscountType) {
                              case "FREE_OFFER":
                                return "FREE OFFER";
                              case "DISCOUNTED_PERCENT":
                                return "DISCOUNTED PERCENT";
                              case "FIXED_DOLLAR":
                                return "FIXED DOLLAR";
                              case "BUY_ONE_GET_ONE_FREE":
                                return "BUY ONE GET ONE FREE";
                              case "BUNDLE_OFFER":
                                return "BUNDLE OFFER";
                              default:
                                return "None";
                            }
                          })()}
                        </TruncatedTableCell>
                        <TableCell
                          className="!px-2 whitespace-nowrap"
                          style={{
                            width: "1%",
                            minWidth: "120px",
                            overflow: "visible",
                          }}
                        >
                          <Confirmation
                            status={offer?.status}
                            onStatusClick={handleStatusClick}
                            offerId={offer?._id}
                            enableMerchantStatusAction={true}
                            handleInfoClick={() => handleInfoClick(offer)}
                            creatorRole={offer?.creatorRole}
                            showInProcess={false}
                            showRejectedLabel={[
                              "declined",
                              "rejected",
                            ].includes(
                              String(offer?.status || "").toLowerCase(),
                            )}
                          />
                        </TableCell>
                        {/* <TableCell>
                      <Status
                        isEnabled={offer?.isEnabled}
                        handleToggle={() => handleToggle(offer?._id)}
                      />
                    </TableCell> */}
                        <TruncatedTableCell className="max-w-[120px]">
                          <button
                            className="flex justify-center items-center border border-[#00ADEF] rounded-[6px] p-3 h-[34px]"
                            onClick={() => openPopup(offer?._id)}
                          >
                            <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins leading-[22px] whitespace-nowrap">
                              View Details
                            </span>
                          </button>
                        </TruncatedTableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {visibleOffers && visibleOffers.length > 0 && (
          <Pagination
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
};

export default MerchantOfferlist;
